import { Button } from "reactstrap";
import { useState, useCallback } from "react";
import { firstDay, lastDay } from "utils/dateHelper";
import moment from "moment";
import _ from "lodash";
import { useForm } from "react-hook-form";
import apiService from "services/api";
import { fileResponseDownloader } from "utils/fileResponseDownloader";

const filterTypes = {
	MONTHLY: "absolute_month",
	DAILY: "day",
	WEEKLY: "week",
	ALL: "all",
	RANGE: "range",
};

const StudentSummary = ({ student }) => {
	const {
		register,
		setValue,
		getValues,
		handleSubmit,
		formState: { errors },
	} = useForm({
		defaultValues: {
			date_from: firstDay(undefined, filterTypes.MONTHLY),
			date_to: lastDay(undefined, filterTypes.MONTHLY),
		},
	});

	const [activeDateFilterButton, setActiveDateFilterButton] = useState(filterTypes.MONTHLY);

	const handleActiveFilterChange = (filterType) => () => {
		setActiveDateFilterButton(filterType);
		if (filterType === filterTypes.ALL) {
			setValue("date_from", "");
			return setValue("date_to", "");
		}
		const [start, end] = [firstDay(undefined, filterType), lastDay(undefined, filterType)];
		setValue("date_from", start);
		setValue("date_to", end);
	};

	const generateReport = useCallback(
		(data) => {
			const params = _.pickBy(data, (value, key) => value !== "");
			apiService.report.student(student?.id, params).then((data) => {
				const fileName = `${params.date_from ? params.date_from + "_" : ""}${params.date_to ? params.date_to + "_" : ""}${student.firstName}_${student.lastName}.xlsx`;
				fileResponseDownloader({ fileName, data });
			});
		},
		[student]
	);

	return (
		<>
			<div className="mx-1">
				<div className="font-weight-bold text-info display-5 mb-2">Report</div>
				<div className="btn-group">
					<Button size="sm" color={`${activeDateFilterButton === filterTypes.ALL && "info"}`} onClick={handleActiveFilterChange(filterTypes.ALL)}>
						<small className="font-weight-bold">All</small>
					</Button>
					<Button size="sm" color={`${activeDateFilterButton === filterTypes.MONTHLY && "info"}`} onClick={handleActiveFilterChange(filterTypes.MONTHLY)}>
						<small className="font-weight-bold">Monthly</small>
					</Button>
					<Button size="sm" color={`${activeDateFilterButton === filterTypes.WEEKLY && "info"}`} onClick={handleActiveFilterChange(filterTypes.WEEKLY)}>
						<small className="font-weight-bold">Weekly</small>
					</Button>
					<Button size="sm" color={`${activeDateFilterButton === filterTypes.DAILY && "info"}`} onClick={handleActiveFilterChange(filterTypes.DAILY)}>
						<small className="font-weight-bold">Daily</small>
					</Button>
				</div>
				<form className="row align-items-center mt-2" onSubmit={handleSubmit(generateReport)}>
					<div className="col-sm-6 col-md-4">
						<div className="d-flex mb-2 align-items-center">
							<small className="font-weight-bold mr-2 text-white">From:</small>
							<input
								type="date"
								className="form-control form-control-sm"
								{...register("date_from", {
									validate: {
										checkLessThan: (date_from) => !Boolean(date_from) || moment(date_from) < moment(getValues("date_to")) || "Date From must be less than Date To",
									},
								})}
							/>
						</div>
						{errors.date_from && (
							<div className="text-center text-danger">
								<small>{errors.date_from?.message}</small>
							</div>
						)}
					</div>
					<div className="col-sm-6 col-md-4">
						<div className=" d-flex mb-2 align-items-center">
							<small className="font-weight-bold mr-2 text-white">To:</small>
							<input
								type="date"
								className="form-control form-control-sm"
								{...register("date_to", {
									validate: {
										checkMoreThan: (date_to) => !Boolean(date_to) || moment(getValues("date_from")) < moment(date_to) || "Date From must be less than Date To",
									},
								})}
							/>
						</div>
						{errors.date_to && (
							<div className="text-center text-danger">
								<small>{errors.date_to?.message}</small>
							</div>
						)}
					</div>
					<div className="col-sm-6 col-md-4 d-flex mb-2 align-items-center">
						<Button size="sm" color="info">
							<small className="font-weight-bold text-nowrap">Generate Student Summary</small>
						</Button>
					</div>
				</form>
			</div>
		</>
	);
};

export default StudentSummary;
